export const handleSubmit = ({ sourceId, updateSource, history, sourceToEdit, currentCustomerId }) => values => {
  const updatedData = updateSource({
    variables: {
      sourceInput: values,
      customerId: currentCustomerId,
      sourceId,
    },
  });

  return updatedData.then(result => {
    const source = result.data ? result.data.updateSource : null;
    if (source) {
      history.goBack();
    }
  });
};
